<script setup>
import App from "@/components/App.vue";
import DeviceList from "@/components/device/DeviceList.vue";
import {mdiPlus} from "@mdi/js";
import {ref, useTemplateRef} from "vue";
import CreateDeviceDialog from "@/components/device/CreateDeviceDialog.vue";
import AuthenticationCodeDialog from "@/components/device/AuthenticationCodeDialog.vue";

const deviceList = useTemplateRef("deviceList");
const showCreateDeviceDialog = ref(false);
const showAuthenticationCodeDialog = ref(false);
const lastDeviceAuthenticationRequest = ref(null);

function onCreateDevice(values) {
    deviceList.value?.refresh();
    showAuthenticationCodeDialog.value = true;
    lastDeviceAuthenticationRequest.value = values;
}
function onAuthenticationDialogClose() {
    deviceList.value?.refresh();
}
</script>

<template>
    <App>
        <v-container>
            <v-row>
                <v-col>
                    <h1 class="mt-0">{{ pgettext('title', 'Authorized Devices') }}</h1>

                    <DeviceList ref="deviceList">
                        <template #header-actions>
                            <v-btn :prepend-icon="mdiPlus" color="green" @click="showCreateDeviceDialog = true">
                                {{ pgettext('action', 'Add Device') }}
                            </v-btn>
                        </template>
                    </DeviceList>
                </v-col>
            </v-row>
        </v-container>

        <CreateDeviceDialog v-model="showCreateDeviceDialog"
                            @createDevice="onCreateDevice"/>
        <AuthenticationCodeDialog v-model="showAuthenticationCodeDialog"
                                  :authenticationRequest="lastDeviceAuthenticationRequest"
                                  @close="onAuthenticationDialogClose"/>
    </App>
</template>
